export enum EGender {
    male = 0,
    female = 1,
    notSet = 2
}